import { useEffect, useState } from 'react';
import * as Sentry from '@sentry/react';
import { PassService } from '../../api';
import type { AccountData } from '../../api/models/AccountData';
import type { PassOrderPageAvailabilityOut } from '../../api/models/PassOrderPageAvailabilityOut';
import type { PassOrderPageData } from '../../api/models/PassOrderPageData';

/** Loads the weekly slot availability of a pass. `enabled` lets callers skip the call entirely. */
export const usePassAvailability = (
  passOrderPage: PassOrderPageData | undefined,
  account: AccountData | undefined,
  enabled = true,
) => {
  const [availability, setAvailability] = useState<PassOrderPageAvailabilityOut[] | undefined>();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!enabled || !account || !passOrderPage) return;
    void (async () => {
      setLoading(true);
      setError(false);
      try {
        setAvailability(await PassService.getPassAvailability(passOrderPage.id, account.id));
      } catch (err) {
        Sentry.captureException(err);
        setError(true);
      } finally {
        setLoading(false);
      }
    })();
  }, [account, passOrderPage, enabled]);

  return { availability, loading, error };
};
